// Note: this file is separate from ./models/utils.ts to prevent a dependency cycle

import {PropertyType} from 'common/report/constants';

import type {PropertyFilter} from './models/property-filter';

export function isEnhancedListFilter(filter: PropertyFilter) {
  return (
    filter.listQuantifier &&
    // list property or lookup table property with join key that is a list
    filter.joinPropertyType === PropertyType.List
  );
}
